import React, { useEffect, useState } from 'react';
import './Enquiry_Form_Modal.css';
import { Modal } from 'react-bootstrap';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LeadCaptureForm from '../landing-page/components/LeadCaptureForm';

function Enquiry_Form_Modal({ ...props }) {


  return (
    <>
      <Modal
        className="inquiry-form-modal modal-dialog-scrollable"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
        backdrop="static"
        show={props.show}
        onHide={props.onHide}
      >
        <Modal.Header className="modal-header-centered" closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Inquiry Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-sec-start">
            <div>
              <LeadCaptureForm />
            </div>
          </div>
        </Modal.Body>

        <ToastContainer autoClose={3000} />
      </Modal>
    </>
  );
}

export default Enquiry_Form_Modal;
